import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../styles/theme'

const StyledRadio = styled.label`
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  margin-top: ${props => props.theme.spacing.base300};

  input {
    margin-right: ${props => props.theme.spacing.base400};
    appearance: none;
    background-color: ${colors.neutral100};
    width: 20px;
    height: 20px;
    border-radius: 100%;
    border: 1px solid ${props => props.theme.colors.separator};
    outline: none;
  }

  input:checked {
    border: 1.5px solid ${colors.primary300};
  }

  input:checked::after {
    position: relative;
    display: block;
    content: '';
    width: 13px;
    height: 13px;
    background-color: ${colors.primary300};
    border-radius: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  input:disabled {
    background-color: ${colors.neutral300};
  }
`

const Radio = ({
  children,
  ...props
}: { children: React.ReactNode | React.ReactNodeArray | string } & React.InputHTMLAttributes<
  HTMLInputElement
>) => {
  return (
    <StyledRadio>
      <input type="radio" {...props} />
      {children}
    </StyledRadio>
  )
}

export default Radio
